// Add your custom JS here.

// $(window).scroll(function(){
// 	$('nav').toggleClass('scrolled', $(this).scrollTop() > 50);
// });




// const dialog = document.getElementById('cookie-box'), button = document.getElementById('accept-cookies')

// function isConsent() {
//   window.dispatchEvent(new Event('consent'))
// }

// function consentCookie() {
//   document.cookie = 'consent=true'
//   dialog.hidden = true
//   isConsent()
// }

// button.addEventListener('click', e => consentCookie())

// !document.cookie.split(';').find(e => e.trim() === 'consent=true') ? dialog.hidden = false : isConsent()




// const 
// dialog = document.getElementById('cookie'),
// button = document.getElementById('button')

// function isConsent() {
//   window.dispatchEvent(new Event('consent'))
// }

// function consentCookie() {
//   document.cookie = 'consent=true'
//   dialog.hidden = true
//   isConsent()
// }

// button.addEventListener('click', e => consentCookie())

// !document.cookie.split(';').find(e => e.trim() === 'consent=true') ? dialog.hidden = false : isConsent()



// let cookie_consent = getCookie("user_cookie_consent");
// if(cookie_consent != ""){
//     document.getElementById("cookie-bar").style.display = "block";
// }else{
//     document.getElementById("cookie-bar").style.display = "block";
// }

// // // Create cookie
// function setCookie(cname, cvalue, exdays) {
//   const d = new Date();
//   d.setTime(d.getTime() + (exdays*24*60*60*1000));
//   let expires = "expires="+ d.toUTCString();
//   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
// }

// // // Delete cookie
// function deleteCookie(cname) {
//   const d = new Date();
//   d.setTime(d.getTime() + (24*60*60*1000));
//   let expires = "expires="+ d.toUTCString();
//   document.cookie = cname + "=;" + expires + ";path=/";
// }

// // // Read cookie
// function getCookie(cname) {
//   let name = cname + "=";
//   let decodedCookie = decodeURIComponent(document.cookie);
//   let ca = decodedCookie.split(';');
//   for(let i = 0; i <ca.length; i++) {
//       let c = ca[i];
//       while (c.charAt(0) == ' ') {
//           c = c.substring(1);
//       }
//       if (c.indexOf(name) == 0) {
//           return c.substring(name.length, c.length);
//       }
//   }
//   return "";
// }

// // Set cookie consent
// function acceptCookieConsent(){
//   deleteCookie('user_cookie_consent');
//   setCookie('user_cookie_consent', 1, 30);
//   document.getElementById("cookie-bar").style.display = "block";
// }




jQuery(document).ready(function($) {
  
  //check to see if the submited cookie is set, if not check if the popup has been closed, if not then display the popup
  if( getCookie('popupCookie') != 'submited'){ 
    if(getCookie('popupCookie') != 'closed' ){
      $('.popup-overlay').css("display", "flex").hide().fadeIn();
    }
  }
  
  $('a.close').click(function(){
    $('.popup-overlay').fadeOut();
    //sets the coookie to one minute if the popup is closed (whole numbers = days)
    setCookie( 'popupCookie', 'closed', .00069444444 );
  });
  
  $('a.submit').click(function(){
    $('.popup-overlay').fadeOut();
    //sets the coookie to five minutes if the popup is submited (whole numbers = days)
    setCookie( 'popupCookie', 'submited', 30 );
  });

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
});


// End Cookie




// Slide out modal JS Begin
var slideOut = $('#slide-out-modal');
var slideOut = document.getElementById("slideOut");
var slideOutTab = document.getElementById("slideOutTab");
var closeModal = document.getElementById("btn-close");

closeModal .onclick = function() {
  //alert('clicked');
  slideOut.classList.remove("showSlideOut");
}

slideOutTab.onclick = function() { 
  
 //alert('CLICK');
  if (slideOut.classList.contains('showSlideOut')) {
      // alert("has class");
      //slideOut.classList.remove("showSlideOut");
  }
  else {
      slideOut.classList.add("showSlideOut");
  }
}



